document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initGaleriaProducto();
  initVariantesProducto();
  initHeroParallax();
  initLifestyleSticky();
  initComparador();
});

function initComparador() {
  var visual = document.querySelector('[data-mt-comparador]');
  if (!visual) return;
  var despues = visual.querySelector('[data-mt-comparador-despues]');
  var handle = visual.querySelector('[data-mt-comparador-handle]');
  if (!despues || !handle) return;

  function fijarPorcentaje(porcentaje) {
    porcentaje = Math.max(0, Math.min(100, porcentaje));
    despues.style.clipPath = 'inset(0 ' + (100 - porcentaje) + '% 0 0)';
    handle.style.left = porcentaje + '%';
    handle.setAttribute('aria-valuenow', Math.round(porcentaje));
  }

  function porcentajeDesdeEvento(clientX) {
    var rect = visual.getBoundingClientRect();
    return ((clientX - rect.left) / rect.width) * 100;
  }

  var arrastrando = false;

  function alMover(evento) {
    if (!arrastrando) return;
    var clientX = evento.touches ? evento.touches[0].clientX : evento.clientX;
    fijarPorcentaje(porcentajeDesdeEvento(clientX));
  }

  visual.addEventListener('pointerdown', function (evento) {
    arrastrando = true;
    fijarPorcentaje(porcentajeDesdeEvento(evento.clientX));
  });
  window.addEventListener('pointermove', alMover);
  window.addEventListener('pointerup', function () { arrastrando = false; });
  visual.addEventListener('touchstart', function () { arrastrando = true; }, { passive: true });
  visual.addEventListener('touchmove', alMover, { passive: true });
  window.addEventListener('touchend', function () { arrastrando = false; });

  handle.addEventListener('keydown', function (evento) {
    var actual = parseFloat(handle.style.left) || 50;
    if (evento.key === 'ArrowLeft') { fijarPorcentaje(actual - 5); evento.preventDefault(); }
    if (evento.key === 'ArrowRight') { fijarPorcentaje(actual + 5); evento.preventDefault(); }
  });

  fijarPorcentaje(50);
}

function initLifestyleSticky() {
  var filas = document.querySelectorAll('[data-mt-lifestyle-fila]');
  var fotos = document.querySelectorAll('[data-mt-lifestyle-foto]');
  if (filas.length < 2 || !fotos.length) return;
  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (entrada) {
      if (!entrada.isIntersecting) return;
      var indice = entrada.target.getAttribute('data-mt-lifestyle-fila');
      fotos.forEach(function (foto) {
        foto.classList.toggle('mt-lifestyle-foto-activa', foto.getAttribute('data-mt-lifestyle-foto') === indice);
      });
    });
  }, { threshold: 0.6, rootMargin: '-20% 0px -20% 0px' });

  filas.forEach(function (fila) { observer.observe(fila); });
}

function initHeroParallax() {
  var hero = document.querySelector('[data-mt-hero]');
  var capa = document.querySelector('[data-mt-hero-parallax]');
  if (!hero || !capa) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(max-width: 990px)').matches) return;
  if (!window.matchMedia('(hover: hover)').matches) return;

  var frame = null;
  hero.addEventListener('mousemove', function (evento) {
    if (frame) return;
    frame = requestAnimationFrame(function () {
      var rect = hero.getBoundingClientRect();
      var x = (evento.clientX - rect.left) / rect.width - 0.5;
      var y = (evento.clientY - rect.top) / rect.height - 0.5;
      capa.style.transform = 'translate(' + (x * -14) + 'px, ' + (y * -10) + 'px) scale(1.04)';
      frame = null;
    });
  });
  hero.addEventListener('mouseleave', function () {
    capa.style.transform = 'translate(0, 0) scale(1)';
  });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-mt-imagen-principal]');
  var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
  if (!principal || !miniaturas.length) return;
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      principal.src = mini.getAttribute('data-full');
      principal.alt = mini.getAttribute('data-alt') || '';
      miniaturas.forEach(function (m) { m.classList.remove('mt-galeria-mini-activa'); });
      mini.classList.add('mt-galeria-mini-activa');
    });
  });
}

function initVariantesProducto() {
  var contenedor = document.querySelector('.mt-producto-compra');
  if (!contenedor) return;
  var selects = contenedor.querySelectorAll('[data-mt-opcion-select]');
  var variantesEl = contenedor.querySelector('[data-mt-variantes]');
  if (!selects.length || !variantesEl) return;

  var variantes;
  try { variantes = JSON.parse(variantesEl.textContent); } catch (e) { return; }

  var inputId = contenedor.querySelector('[data-mt-variant-id]');
  var precioEl = contenedor.querySelector('[data-mt-precio]');
  var comparadoEl = contenedor.querySelector('[data-mt-precio-comparado]');
  var ofertaEl = contenedor.querySelector('[data-mt-oferta-badge]');
  var ofertaPorcentajeEl = contenedor.querySelector('[data-mt-oferta-porcentaje]');
  var boton = contenedor.querySelector('[data-mt-boton-comprar]');
  var botonTexto = contenedor.querySelector('[data-mt-boton-texto]');

  function formatearPrecio(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  }

  function actualizar() {
    var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
    var encontrada = variantes.find(function (v) {
      return v.options.every(function (op, i) { return op === seleccion[i]; });
    });
    if (!encontrada) return;
    if (inputId) inputId.value = encontrada.id;
    if (precioEl) precioEl.textContent = formatearPrecio(encontrada.price);
    if (comparadoEl) {
      var enOferta = encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price;
      if (enOferta) {
        comparadoEl.textContent = formatearPrecio(encontrada.compare_at_price);
        comparadoEl.style.display = '';
      } else {
        comparadoEl.style.display = 'none';
      }
      if (ofertaEl) ofertaEl.style.display = enOferta ? '' : 'none';
      if (ofertaPorcentajeEl && enOferta) {
        var porcentaje = Math.round(((encontrada.compare_at_price - encontrada.price) / encontrada.compare_at_price) * 100);
        ofertaPorcentajeEl.textContent = '-' + porcentaje + '%';
      }
    }
    if (boton) {
      boton.disabled = !encontrada.available;
      if (botonTexto) botonTexto.textContent = encontrada.available ? boton.getAttribute('data-texto-disponible') || botonTexto.textContent : boton.getAttribute('data-texto-agotado') || botonTexto.textContent;
    }
  }

  selects.forEach(function (select) { select.addEventListener('change', actualizar); });
}

function initReveal() {
  var elementos = document.querySelectorAll('.mt-reveal');
  if (!elementos.length) return;
  if (!('IntersectionObserver' in window)) {
    elementos.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (entrada) {
      if (entrada.isIntersecting) {
        entrada.target.classList.add('mt-visible');
        observer.unobserve(entrada.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  elementos.forEach(function (el) { observer.observe(el); });
}

function initContador() {
  var contadores = document.querySelectorAll('[data-mt-contador]');
  if (!contadores.length) return;
  var animado = new WeakSet();
  var observer = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (entrada) {
      if (!entrada.isIntersecting || animado.has(entrada.target)) return;
      animado.add(entrada.target);
      var el = entrada.target;
      var fin = parseFloat(el.getAttribute('data-mt-contador'));
      var decimales = (el.getAttribute('data-mt-contador').split('.')[1] || '').length;
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = valor.toFixed(decimales);
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin.toFixed(decimales);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.5 });
  contadores.forEach(function (el) { observer.observe(el); });
}
